module.exports = __webpack_public_path__ + "assets/images/project/people/womansenior.svg?v=28026276";